import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { useLocation } from '../../hooks/queries/location';
import { AutocompleteRenderer } from './AutocompleteRenderer';
import './CategoryBrowseLocationAutocomplete.scss';
import { LocationFilterPill } from './LocationFilterPill';
import { LocationSelectError } from './types';

export const CategoryBrowseLocationAutocomplete: any = withRouter((props) => {
    const autocompleteInputRenderBuffer = React.useRef(false);

    const [waitingForLocation, setWaitingForLocation] = React.useState(false);
    const [error, setIsError] = React.useState<LocationSelectError>(null);
    const [renderFullAutocomplete, setRenderFullAutocomplete] =
        React.useState(false);

    const { data: currentLocation } = useLocation();

    const handleRenderingFullAutocomplete = (val: boolean) => {
        if (val === false && renderFullAutocomplete) {
            if (autocompleteInputRenderBuffer.current) {
                setRenderFullAutocomplete(false);
                autocompleteInputRenderBuffer.current = false;
            } else {
                autocompleteInputRenderBuffer.current = true;
            }
        }
    };

    const displayLocation = currentLocation?.isOnline
        ? gettext('Online').toString()
        : currentLocation?.currentPlace || gettext('Location').toString();

    return (
        <div
            className="category-browse__location-autocomplete"
            data-heap-id="category-browse-search-location"
        >
            <div className="category-browse__location-autocomplete--stub-container">
                {renderFullAutocomplete ? (
                    <AutocompleteRenderer
                        currentLocation={currentLocation}
                        displayLocation={displayLocation}
                        setIsError={setIsError}
                        match={props.match}
                        location={props.location}
                        onLocationSelect={() => setWaitingForLocation(true)}
                        resolveLocationSelect={() => {
                            setWaitingForLocation(false);
                            setRenderFullAutocomplete(false);
                        }}
                        history={props.history}
                        handleRenderingFullAutocomplete={
                            handleRenderingFullAutocomplete
                        }
                    />
                ) : (
                    <LocationFilterPill
                        error={error}
                        waitingForLocation={waitingForLocation}
                        displayLocation={displayLocation}
                        clearError={() => setIsError(null)}
                        toggleAutocomplete={() =>
                            setRenderFullAutocomplete(true)
                        }
                    />
                )}
            </div>
        </div>
    );
});
